import { Box, Typography } from '@mui/material';
import { generateIdeasLoaderSx } from './blogPostCss';

export const GenerateIdeasLoader = ({
  title,
  isPdf = null,
  isPdfLoader = null
}) => {
  return (
    <Box sx={generateIdeasLoaderSx?.mainBox}>
      <img
        style={generateIdeasLoaderSx?.spinner}
        src="/static/images/icons/blog-post-spinner.gif"
        alt="Loading"
      />
      <Typography sx={generateIdeasLoaderSx?.desc}>{title}</Typography>
      {isPdf && (
        <Typography
          sx={{
            ...generateIdeasLoaderSx?.desc,
            fontSize: 'var(--font-size-16)',
            lineHeight: 'var(--line-height-22)',
            marginTop: '14px',
            fontWeight: 500
          }}
        >
          {
            'Please note: Google Search Console data is available only from the date it was set up, which may be after the first SEOSpace audit date. As a result, the dates in this report might be different.'
          }
        </Typography>
      )}
    </Box>
  );
};
